import CaseStudyCard from "../../reusables/CaseStudyCard";
import k9 from "../../../assets/images/case-studies/gk9.jpg";

const K9CaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={k9}
      client="Great Habib K9 Academy"
      solution="website design"
      title="Website design and development for East Africa's home of trained dogs"
      subtitle="This leading East Africa dog services company needed a high-performance web presence."
      link="https://ghk9academy1.web.app"
    >
      <li>
        ✔︎ <span>Professional Emails</span>
      </li>
      <li>
        ✔︎ <span>Website development</span>
      </li>
      <li>
        ✔︎ <span>Google business profile</span>
      </li>
      <li>
        ✔︎ <span>Orders Management App</span>
      </li>
      <li>
        ✔︎ <span>Website Management & Maintenance</span>
      </li>
    </CaseStudyCard>
  );
};

export default K9CaseStudyCard;
